export const routes = [
  {
    path: '/measure/singlettr',
    name: 'SingleTtrRegistry',
    component: () => import('../views/SingleTtrRegistry.vue'),
  },
  {
    path: '/measure/singlettr-odnostoron',
    name: 'SingleTtrRegistryOdnostoron',
    component: () => import('../views/SingleTtrRegistryOdnostoron.vue'),
  },
  {
    path: '/measure/singlettr/edit/:id',
    name: 'SingleTtrCard',
    component: () => import('../views/SingleTtrCard.vue'),
  },
  {
    path: '/measure/singlettr-odnostoron/edit/:id',
    name: 'SingleTtrOdnostoronCard',
    component: () => import('../views/SingleTtrOdnostoronCard.vue'),
  },
  {
    path: '/measure/unilateralntr',
    name: 'UnilateralNonTrRegistry',
    component: () => import('../views/UnilateralNonTrRegistry.vue'),
    props: {
      isSecond: false,
      pageTitle: 'Перечень единых мер нетарифного регулирования, применяемых в одностороннем порядке',
    },
  },
  {
    path: '/measure/unilateralntr-odnostoron',
    name: 'UnilateralNonTrRegistryOdnostoron',
    component: () => import('../views/UnilateralNonTrRegistry.vue'),
    props: {
      isSecond: true,
      pageTitle: 'Перечень односторонних мер нетарифного регулирования',
    },
  },
  {
    path: '/measure/unilateralntr/edit/:id',
    name: 'UnilateralNonTrCard',
    component: () => import('../views/UnilateralNonTrCard.vue'),
    props: {
      isSecond: false,
    },
  },
  {
    path: '/measure/unilateralntr-odnostoron/edit/:id',
    name: 'UnilateralNonTrCardOdnostoron',
    component: () => import('../views/UnilateralNonTrCardOdnostoron.vue'),
    props: {
      isSecond: true,
    },
  },
  {
    path: '/measure/eecinvestigations',
    name: 'EecInvestigationRegistry',
    component: () => import('../views/EecInvestigationRegistry.vue'),
  },
  {
    path: '/measure/eecinvestigations/edit/:id',
    name: 'EecInvestigationCard',
    component: () => import('../views/EecInvestigationCard.vue'),
  },
  {
    path: '/measure/reqsinitiativesttr',
    name: 'RequestInitiativeTtrRegistry',
    component: () => import('../views/RequestInitiativeTtrRegistry.vue'),
  },
  {
    path: '/measure/reqsinitiativesttr/edit/:id',
    name: 'RequestInitiativeTtrCard',
    component: () => import('../views/RequestInitiativeTtrCard.vue'),
  },
  {
    path: '/measure/reqsinitiativesttr/add',
    name: 'RequestInitiativeTtrCardAdd',
    component: () => import('../views/RequestInitiativeTtrCardAdd.vue'),
  },
  {
    path: '/measure/marketdefence',
    name: 'MarketDefenceRegistry',
    component: () => import('../views/MarketDefenceRegistry.vue'),
  },
  {
    path: '/measure/marketdefence/edit/:id',
    name: 'MarketDefenceCard',
    component: () => import('../views/MarketDefenceCard.vue'),
  },
];
